export const staffPermissions = [
	"salary.views.employeeview",
	"salary.views.employmentview",
	"time.views.timereportview",
	"time.views.hoursreportandsalaryview",
	"salary.views.absenceview",
	"salary.views.additiondeductionview",
	"salary.views.taxviewse",
	"salary.views.taxviewno",
	"salary.views.absenceview",
	"salary.views.formsView",
	"salary.views.salaryrevision",
	"salary.views.shiftPayments",
	"time.views.monthlyroutinesview",
	"salary.views.restrictedwarninglist",
	"payrolllists.view",
	"time.views.reconciliationView",
	"time.views.ledger",
	// "portal.handleOwnHours",
	"time.views.reconciliationView",
	"schedule.views.main",
	"schedule.views.print",
	"schedule.views.shiftlist",
	"communication.views.messages",
	"communication.views.documents",
	"systemNews.admin",
	"tip.views.distribution",
	"tip.views.history",
	"tip.views.payment",
	"tip.views.bankfile",
	"tip.views.conflicts",
];

export const bookingPermissions = [
	"booking.views.communication",
	"booking.get",
	"booking.views.administration",
	"surveys.survey.get",
	"invoice.invoiceInformation.get",
	"invoice.invoiceInformation.update",
	"booking.get",
	"invoice.invoiceInformation.multiple",
];

export const analyticsPermssions = [
	"benchmark.view",
	"toplists.view",
	"toplists.matrix",
	"toplists.operations",
	"toplists.byHourInDay",
	"salesBenchmark.view",
	"dashboard.view",
	"time.views.resultView",
];
